import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_PORTFOLIO_TEMPLATES = gql`
  query fetchPortfolioTemplates($input: FetchPortfolioTemplatesInput!) {
    fetchPortfolioTemplates(input: $input) {
      portfolioTemplates {
        id
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            key
            name
          }
        }
        createdAt
        id
        name
        state
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        updatedAt
        translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
      }
      totalCount
    }
  }
`;

export const CREATE_PORTFOLIO_TEMPLATE = gql`
  mutation createPortfolioTemplate($input: CreatePortfolioTemplateInput!) {
    createPortfolioTemplate(input: $input) {
      portfolioTemplate {
        assetClassBranches {
          assetClass {
            description
            id
            includeCash
            key
            name
            state
          }
          id
          targetPercentage
        }
        createdAt
        id
        name
        state
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
        updatedAt
      }
    }
  }
`;

export const UPDATE_PORTFOLIO_TEMPLATE = gql`
  mutation updatePortfolioTemplate($input: UpdatePortfolioTemplateInput!) {
    updatePortfolioTemplate(input: $input) {
      portfolioTemplate {
        id
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            key
            name
          }
        }
        createdAt
        id
        name
        state
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        updatedAt
        translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;

export const TRANSITION_PORTFOLIO_TEMPLATE = gql`
  mutation transitionPortfolioTemplate($input: TransitionPortfolioTemplateInput!) {
    transitionPortfolioTemplate(input: $input) {
      portfolioTemplate {
        id
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            key
            name
          }
        }
        createdAt
        id
        name
        state
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        updatedAt
        translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
